import * as React from 'react';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {contentSelector} from '../../../../../redux/selectors/resources';
import {GetHolderProfileCabinetResponsePayload} from '../../../../../shared/models/api';
import View from './view';

export const ProfileSafety = () => {
  const content = useSelector(contentSelector());
  const {uscIsBlocked = false} = (useSelector(holderProfileSelector()) || {}) as GetHolderProfileCabinetResponsePayload;

  return <View cardIsBlocked={uscIsBlocked} content={content} />;
};
